import { collection, getDocs, query } from "firebase/firestore";
import { GetManyReferenceParams, GetManyReferenceResult } from "react-admin";
import { applyFilter, applyPagination, applySort } from "../backoffice.utils";
import { firestore } from "../firebase";
import { PostalAddress } from "../model/PostalAddress";
import { favoriteLocationsConverter } from "./converter/favoriteLocationsConverter";
import { AbstractDataProvider } from "./AbstractDataProvider";

export interface InstructorFavoriteLocation {
  id: string;
  name: string;
  postalAddress: PostalAddress;
}

class InstructorFavoriteLocationsProvider extends AbstractDataProvider<InstructorFavoriteLocation> {
  async getManyReference(
    _resource: string,
    { target, id, pagination, sort, filter }: GetManyReferenceParams,
  ): Promise<GetManyReferenceResult<InstructorFavoriteLocation>> {
    if (target !== "instructorId") {
      throw new Error(`Unexpected target: ${JSON.stringify(target)} -- expected: "instructorId"`);
    }
    const query_ = query(collection(firestore, `/users/${id}/favorite_locations`));
    const snapshot = await getDocs(query_.withConverter(favoriteLocationsConverter));
    const favoriteLocations = snapshot.docs.map((it) => it.data()).flat();
    return applyPagination(applySort(applyFilter(favoriteLocations, filter), sort), pagination);
  }
}

export const instructorFavoriteLocationsProvider = new InstructorFavoriteLocationsProvider();
